// src/contexts/TranslationContext.js
import { createContext } from 'react';

const TranslationContext = createContext({
    locale: 'en',
    translations: {},
    changeLocale: async () => { },
});

export { TranslationContext };